module.exports = __webpack_public_path__ + "media/images/thank_you_mobile-231655a74eb89e029b5d7a11b3f4834e.png";